// useStreakSummary.js

import { useMemo } from "react";

const useStreakSummary = (records) => {

    const summary = useMemo(() => {
        const result = {};

        (records || []).forEach((r) => {
            const mod = r.streakModule || "Others";
            const p   = (r.particulars || "").toLowerCase();
            const t   = (r.streakType  || "").toLowerCase();

            if (!result[mod]) {
                result[mod] = {
                    daily:        0,
                    login:        0,
                    win:          0,
                    consistency:  0,
                    finditlocal:  0,
                    learning:     0,
                    hustle:       0,
                };
            }

            if (p.includes("daily")    || t === "daily")        result[mod].daily++;
            if (p.includes("login")    || t === "login")        result[mod].login++;
            if (p.includes("win")      || t === "win")          result[mod].win++;
            if (p.includes("consisten")|| t === "consistency")  result[mod].consistency++;
            if (t === "finditlocal"    || mod === "FindItLocal") result[mod].finditlocal++;
            if (t === "learning"       || mod === "Learning")   result[mod].learning++;
            if (t === "hustle"         || mod === "Hustle")     result[mod].hustle++;
        });

        // Remove empty modules
        Object.keys(result).forEach((key) => {
            const vals = Object.values(result[key]);
            if (vals.every((v) => v === 0)) delete result[key];
        });

        return result;
    }, [records]);

    // Running balance — sum all balance fields
    const balance = useMemo(() => {
        return (records || []).reduce((sum, item) => {
            // Out entries have negative balance in schema
            return sum + (item.balance || 0);
        }, 0);
    }, [records]);

    // Total IN points
    const totalIn = useMemo(() => {
        return (records || [])
            .filter((r) => r.inOutType === "In")
            .reduce((s, r) => s + (r.points || 0), 0);
    }, [records]);

    // Total OUT points
    const totalOut = useMemo(() => {
        return (records || [])
            .filter((r) => r.inOutType === "Out")
            .reduce((s, r) => s + (r.points || 0), 0);
    }, [records]);

    return { summary, balance, totalIn, totalOut };
};

export default useStreakSummary;
